import HotWalletsTableView from './hotWalletsTableView';

export default HotWalletsTableView;
